import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder } from '@angular/forms';
import { sortCrewMembers } from 'src/app/flight-logs/flight-log-form-helper';
import { EmployeeDto } from 'src/app/shared/flight-log-api/employees/employee-client.model';
import {
  CrewMemberDto,
  crewRoleDisplay,
} from 'src/app/shared/flight-log-api/shared/shared-client.model';

@Component({
  selector: 'fl-flight-crew',
  templateUrl: './flight-crew.component.html',
  styleUrls: ['./flight-crew.component.scss'],
})
export class FlightCrewComponent implements OnInit {
  @Input()
  public flightCrew: UntypedFormArray;
  @Output()
  public crewSelected = new EventEmitter<EmployeeDto>();

  private crewRoleDisplay = crewRoleDisplay;
  public sortCrewMembers = sortCrewMembers;

  constructor(private fb: UntypedFormBuilder) {}

  public ngOnInit() {}

  public removeMember(member: CrewMemberDto) {
    const index = (this.flightCrew.value as CrewMemberDto[]).indexOf(member);
    this.flightCrew.removeAt(index);
  }

  public emitSelect(employee: EmployeeDto) {
    this.crewSelected.emit(employee);
  }
}
